import IndexController from '../index_controller'

export default class extends IndexController {
  static values = {
    massNotificationId: String
  }

  connect () {
    super.connect()
  }

  getUrl () {
    return 'admin'
  }

  buildFilters () {
    return super.buildFilters()
  }
}
